function getCookieParam(param) {
    let paramVal = '';
    document.cookie.split('; ').forEach(item => {
        if (item.split('=')[0] === param) {
            paramVal = item.split("=")[1];
        }
    });
    return paramVal;
}

export default getCookieParam;